<template>
  <a-modal
    :class="['custom_modal', 'choose-file']"
    v-model:visible="visible"
    :closable="false"
    :centered="true"
    :footer="null"
  >
    <div class="top-bar">
      <div class="title" v-if="checkedNum > 0">
        已选择<span>{{ checkedNum }}</span
        >个
      </div>

      <SortFile @sort="getAllList" rlogKey="set"></SortFile>
      <div class="filter-btn" @click="changeFilter">
        筛选无字幕文件
        <div :class="['check-btn', isFilter ? 'checked' : '']"></div>
      </div>
    </div>
    <NavBar
      @setParentNavList="setParentNavList"
      :parentNavList="parentNavList"
      :title="title"
    ></NavBar>
    <div class="modal-content">
      <div class="top-title">我的文件夹</div>
      <a-collapse v-model="activeKeys" @change="change">
        <a-collapse-panel
          v-for="(column, index) in columnList"
          :key="index"
          :showArrow="false"
          :destroyInactivePanel="false"
        >
          <template v-slot:header>
            <div :class="['folder-line', { active: current == index }]" @click="setNav(index)">
              <div :class="['folder-icon']"></div>
              <div
                class="column-title"
                @dblclick="
                  setParentNavList('push', column.parentColumnKey);
                  changeColumnKey(column.columnKey);
                "
              >
                {{ column.title }}
              </div>
            </div>
          </template>
          <!-- <FileList
            :isFilter="isFilter"
            :dataSource="column.articleList"
            :checkedList="checked[column.columnKey]?.chooseList"
            @checkFile="
              file => {
                checkFile(file, column.audioLen);
              }
            "
          /> -->
        </a-collapse-panel>
      </a-collapse>

      <div class="my-file-area">
        <div class="top-title">我的文件</div>
        <div :class="['folder-line-icon']">
          <div
            :data-rlog="getIsFolderChecked(columnKey) ? 'set_my_file_cancel' : 'set_my_file_choose'"
            :class="['check-btn', getIsFolderChecked(columnKey) ? 'checked' : '']"
            @click="checkFolder({ columnKey: columnKey, articleList })"
          ></div>
        </div>
      </div>

      <div class="my-file">
        <FileList
          :isFilter="isFilter"
          :dataSource="articleList"
          :checkedList="checked[columnKey]?.chooseList"
          @checkFile="
            file => {
              checkFile(file, articleList, isFilter);
            }
          "
        />
      </div>

      <div class="footer">
        <div class="tips" v-show="showTips">注：重新生成字幕后，原文件将被替换</div>
        <div class="btns">
          <a-button
            class="custom_ok_btn"
            key="submit"
            type="primary"
            :data-rlog="`${rlogKey}_y`"
            @click="
              onConfirm();
              setParentNavList('init', true); // 为true
            "
            size="large"
            >确认</a-button
          >
          <a-button
            class="custom_cancel_btn"
            key="back"
            :data-rlog="`${rlogKey}_n`"
            @click="
              toggleModal(false);
              setParentNavList('init');
            "
            size="large"
            >取消</a-button
          >
        </div>
      </div>
    </div>
  </a-modal>

  <div class="toggle-btn" @click="toggleModal" :data-rlog="rlogKey">
    <slot />
  </div>
</template>
<script>
import { watch, ref, onMounted } from 'vue';
import SortFile from '@/components/SortFile/index.vue';
import { getAudioType } from '../../../../controller/config';
import FileList from './FileList.vue';
import getList from './getList';
import './index.scss';
import check from './methods';
import NavBar from '@/components/NavBar/index.vue';

export default {
  components: {
    SortFile,
    FileList,
    NavBar,
  },
  props: {
    langType: String,
    rlogKey: String,
  },
  setup(props, context) {
    const visible = ref(false);
    const isFilter = ref(false); // 筛选无字幕文件
    const activeKeys = ref([]); // 打开的文件夹index
    const columnList = ref([]); // 文件夹列表
    const articleList = ref([]); // 文件列表
    const parentNavList = ref([]); // 全部文件和当前title中间的一个个的箭头代表的路径(不包括当前文件夹)
    const title = ref(''); // 当前文件夹名称
    const current = ref(-1);
    const defaultColumnKey = 'defaultColumnKey';
    const columnKey = ref(defaultColumnKey); // 当前文件夹对应的columnKey

    function setNav(index) {
      current.value = index;
    }
    function setData(data) {
      articleList.value = data.articleList;
      columnList.value = data.columnList;
      if (columnKey.value === defaultColumnKey) {
        title.value = ''; // 如果是defaultcolumkey。只显示默认文件
      } else {
        title.value = data.ColumnInfo.title;
      }

      columnList.value = columnList.value.map(column => {
        return {
          ...column,
        };
      });
    }
    const { getAllList } = getList(setData);
    function changeColumnKey(columnkey) {
      columnKey.value = columnkey;
    }

    watch(columnKey, newValue => {
      if (newValue) {
        const params = { sortKey: 'alphabeticIncrease', columnKey: newValue };
        getAllList(params);
      }
    });
    onMounted(() => {
      getAllList();
    });
    let checkFun;
    function toggleModal(value) {
      if (!value && checkFun?.clear) {
        checkFun.clear();
      }
      visible.value = value;
    }
    checkFun = check(props, context, toggleModal, isFilter);
    function changeFilter() {
      if (isFilter.value) {
        window._rlog.push(['_trackEvent', 'set_chose_click_cancel']);
      } else {
        window._rlog.push(['_trackEvent', 'set_chose_click_nlrc']);
      }
      isFilter.value = !isFilter.value;
      checkFun.handleFilter(isFilter.value, articleList.value, columnList.value);
    }
    function setParentNavList(type, item, index) {
      if (type === 'slice') {
        checkFun.handleFilter();
        changeColumnKey(item);
        setNav();
        parentNavList.value = parentNavList.value.slice(0, index);
      }
      if (type === 'push') {
        checkFun.handleFilter();
        setNav();
        if (item !== '') {
          parentNavList.value.push(item);
        }
      }
      if (type === 'init') {
        setNav();
        changeColumnKey(defaultColumnKey);
        parentNavList.value.length = 0;
        if (!item) {
          checkFun.handleFilter();
        }
      }
    }
    function change(key) {
      activeKeys.value = key;
    }
    return {
      defaultColumnKey,
      setNav,
      current,
      getAllList,
      visible,
      toggleModal,
      changeFilter,
      isFilter,
      activeKeys,
      getAudioType,
      columnList,
      articleList,
      change,
      ...checkFun,
      parentNavList,
      setParentNavList,
      title,
      changeColumnKey,
      columnKey,
    };
  },
};
</script>
